import { faSign } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap-5';
import ScoreBadges from '../search/components/results/score_badges';
import PropertyActions from './property_actions';
import AddPropertyToRethink from './add_to_rethink/add_property_to_rethink';
import { USD } from 'helpers/formatters/number_formats';
import AddToRethinkList from './add_to_rethink/add_to_rethink_list';
import { selectEmbeddedMode } from '../store/selectors/ui';
import { EMBEDDED_MODES } from '../embedded_mode';
import { useSelector } from 'react-redux';

type Props = {
  fullscreen: boolean;
  hasProfile: boolean;
  products: {
    prospecting: boolean
  };
  property: any;
}

export default function PropertyHeader(
  { fullscreen, hasProfile, products, property }: Props
) {
  const embeddedMode = useSelector(selectEmbeddedMode);
  const inEmbedded = EMBEDDED_MODES.includes(embeddedMode);
  const hasActiveSaleListing = (listings) => {
    return listings.forSale && listings.salePrice && listings.salePrice > 0;
  };

  return (
    <div className="p-4 border-bottom hover-toggle-parent">
      <div className={fullscreen ? 'container-lg' : 'px-4'}>
        <Row className="align-items-center gy-2">
          <Col className="d-flex flex-column gap-2">
            {property.listings.forSale && (
              <div className="d-flex align-items-center gap-1 small text-secondary">
                <FontAwesomeIcon icon={faSign} />
                On Market
              </div>
            )}
            {!property.listings.forSale && <ScoreBadges scores={property.scores} />}
            <div>
              {hasActiveSaleListing(property.listings) && (
                <>
                  <h3 className="m-0 text-nowrap">{USD.format(property.listings.salePrice)}</h3>
                  <div className="text-muted text-nowrap">{property.address}</div>
                </>
              )}
              {!hasActiveSaleListing(property.listings) && (
                <h3 className="m-0 text-nowrap">{property.address}</h3>
              )}
              <div className="text-muted text-nowrap">{property.city}, {property.state}, {property.zip}</div>
            </div>
          </Col>
          {property.insightsAdminLink && (
            <Col xs="auto">
              <Button
                className="btn-shaded-warning hover-v-hidden"
                href={property.insightsAdminLink}
                size="sm"
                target="_blank"
              >
                Admin
              </Button>
            </Col>
          )}
          {hasProfile && !inEmbedded && (
            <Col xs="auto">
              <PropertyActions
                bookmarked={property.bookmarked}
                insightsPropertyId={property.propertyId}
                products={products}
              />
            </Col>
          )}
          {hasProfile && inEmbedded && embeddedMode === 'rethink' && (
            <>
              <Col xs="auto">
                <AddPropertyToRethink
                  insightsPropertyId={property.propertyId}
                  lastFetched={property.ownershipsFetchedAt}
                  propertySyncedAt={property.syncedWithRethinkAt}
                />
              </Col>
              <Col xs="auto">
                <AddToRethinkList insightsPropertyId={property.propertyId} itemCount={1} />
              </Col>
            </>
          )}
        </Row>
      </div>
    </div>
  );
}
